module.exports = __webpack_public_path__ + "static/media/champagne@3x.7193835e.png";